/* 検索結果表示ダイアログ */
import React, { memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
var SearchResultDialog = function (_a) {
    var is_confirm = _a.is_confirm, details = _a.details, show = _a.show, body = _a.body, title = _a.title, handleChange = _a.handleChange, ClickCallBackYes = _a.ClickCallBackYes, ClickCallBackNo = _a.ClickCallBackNo, ClickCallBackConfirm = _a.ClickCallBackConfirm;
    return (React.createElement(Modal, { size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, { className: "dialog-title" }, title)),
        React.createElement(Modal.Body, { className: "dialog-body" }, details.length >= 2 ? (React.createElement("div", null, details.map(function (detail, index) {
            return (React.createElement("label", { className: "radio-label search-result", key: index },
                React.createElement(Form.Check, { type: "radio", value: detail.value, name: detail.form_name, onChange: handleChange, className: "radio-button" }),
                detail.value));
        }))) : (body)),
        React.createElement(Modal.Footer, null, is_confirm ? (React.createElement(Button, { variant: "main-color", onClick: ClickCallBackConfirm }, "\u78BA\u8A8D")) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackYes }, "OK"),
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackNo }, "\u30AD\u30E3\u30F3\u30BB\u30EB"))))));
};
export default memo(SearchResultDialog);
